import { ApplicationConfig, importProvidersFrom, APP_INITIALIZER } from '@angular/core';
import { provideRouter, withInMemoryScrolling, withRouterConfig } from '@angular/router';
import { AngularFireModule } from "@angular/fire/compat";
import { AngularFireDatabaseModule } from "@angular/fire/compat/database";

import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { environment } from '../environments/environment';
import { provideHttpClient } from '@angular/common/http';
import { ApplicationInitializationService } from './shared/services/app-init.service';

export function initializeApp(appInitService: ApplicationInitializationService) {
  return (): Promise<void> => appInitService.init();
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
        anchorScrolling: 'enabled'
      }),
      withRouterConfig({
        onSameUrlNavigation: 'reload'
      })
    ),
    provideHttpClient(),
    provideClientHydration(),
    provideAnimationsAsync(),
    importProvidersFrom([
      AngularFireModule.initializeApp(environment.firebase),
      AngularFireDatabaseModule
    ]),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [ApplicationInitializationService],
      multi: true
    }
  ]
};
